import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box16_UnableToWork: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">16. DATES PATIENT UNABLE TO WORK</Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Controller
          name="unableToWorkFrom"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              type="date"
              size="small"
              placeholder="From"
            />
          )}
        />
        <Controller
          name="unableToWorkTo"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              type="date"
              size="small"
              placeholder="To"
            />
          )}
        />
      </Box>
    </>
  );
};